import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import settings from "../../settings";

class Demographics extends Component {
  state = {
    rows: []
  };
  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  getMaritalStatus = record => {
    let maritalStatus = _.get(record, "person[0].maritalStatus[0]._", "");
    if (maritalStatus === "") {
      maritalStatus = _.get(
        record,
        "person[0].searchResults[0]maritalStatus[0]._",
        ""
      );
    }
    return maritalStatus;
  };

  getGenderValue = gender => {
    switch (gender) {
      case "M":
        return "Male";
      case "F":
        return "Female";
      case "":
        return "Unknown";
      default:
        return gender;
    }
  };

  loadData = props => {
    const rows = [];
    rows.push(
      <Table.Row key={`demo_row_title`} className="report-sub-section-header">
        <Table.Cell>
          <span className={`text-bold`}>Demographics </span>
        </Table.Cell>
      </Table.Row>
    );
    const maritalStatus = this.getMaritalStatus(props.record);
    if (maritalStatus !== "") {
      rows.push(
        <Table.Row key={`demo_row_maritalStatus`}>
          <Table.Cell>
            <span className={`text-bold`}>Marital Status: </span>
            {maritalStatus}
          </Table.Cell>
        </Table.Row>
      );
    }
    const ofac = _.get(props.record, "OFAC[0]._", "");
    _.forEach(_.get(props.record, "searchResults"), (searchResult, index) => {
      if (settings.appName !== "locateamerica") {
        rows.push(
          <Table.Row key={`demo_row_serach_result_ofac_${index}`}>
            <Table.Cell>
              <span className={`text-bold`}>OFAC: </span>
              {ofac}
            </Table.Cell>
          </Table.Row>
        );
      }
      const gender = _.get(searchResult, "gender[0]._", "");
      rows.push(
        <Table.Row key={`demo_row_serach_result_gender_${index}`}>
          <Table.Cell>
            <span className={`text-bold`}>Gender: </span>
            {this.getGenderValue(gender)}
          </Table.Cell>
        </Table.Row>
      );
      const occupation = _.get(searchResult, "occupation[0]._", "");
      rows.push(
        <Table.Row key={`demo_row_serach_result_occupation_${index}`}>
          <Table.Cell>
            <span className={`text-bold`}>Occupation: </span>
            {occupation === "" ? "Unknown" : occupation}
          </Table.Cell>
        </Table.Row>
      );
      const ethnicCode = _.get(searchResult, "ethnicCode[0]._", "");
      rows.push(
        <Table.Row key={`demo_row_serach_result_ethnicCode_${index}`}>
          <Table.Cell>
            <span className={`text-bold`}>Ethnicity: </span>
            {ethnicCode === "" || ethnicCode === "UNCODED"
              ? "Unknown"
              : `${_.get(searchResult, "ethnicCode[0]._", "")} ${_.get(
                  searchResult,
                  "ethnicGroup[0]._",
                  ""
                )}`}
          </Table.Cell>
        </Table.Row>
      );
      const education = _.get(searchResult, "education[0]._", "");
      rows.push(
        <Table.Row key={`demo_row_serach_result_education_${index}`}>
          <Table.Cell>
            <span className={`text-bold`}>Education: </span>
            {education === "" ? "Unknown" : education}
          </Table.Cell>
        </Table.Row>
      );
    });

    this.setState({ rows });
  };

  render() {
    return (
      <Table key={`demo_table_col1`}>
        <Table.Body>{this.state.rows}</Table.Body>
      </Table>
    );
  }
}

export default Demographics;



// WEBPACK FOOTER //
// ./src/components/reports/Demographics.js